'use strict';
const componentTemplate = require('./selector-item.html');

module.exports = {
  template: componentTemplate,
  bindings: {
    model: '=',
  },
  controller: [
    '$miscUtils',
    'selectorsService',
    FormSelectorItemController],
};

function FormSelectorItemController(
  $miscUtils,
  selectorsService,
) {
  console.log('FormSelectorItemController');
  const vm = this;
  this.selectForm = $miscUtils.blockPromise(selectForm);

  function selectForm() {
    return selectorsService.selectForm().then(function (form) {
      vm.model = form;
    });
  }
}

FormSelectorItemController.prototype.toString = toString;

/**
 * TODO(i18n):
 * @return {string}
 * @memberof FormSelectorItemController.prototype
 */
function toString() {
  return this.model ? this.model.title : 'No Form Selected';
}



// WEBPACK FOOTER //
// ./src/js/forms/selector/FormSelectorItem.js